import { Base } from "@/atoms-react/text/Text.react.tsx";
import { Checkbox } from "@/atoms-react/input-checkbox/index.react.tsx";
import { useTranslation } from "react-i18next";
import Loader from "@/atoms-react/loader/Loader.react.tsx";
import InputLabel from "@/atoms-react/input/Input.react";
import type { bronzeCategories } from "@/features/user/quiz/types";
import { useState } from "react";
import { usei18n } from "@/features/utils/hooks/use-i18n";

export const OriginAssets = ({
  setFormResponseOOA,
  setFormResponseOOAComment,
  originAssetsProps,
  sourceIncomeItems,
  isLoadingSourcesIncome,
  commentProps
}: {
  setFormResponseOOA: (sourceIncome: bronzeCategories, isChecked: boolean) => void;
  originAssetsProps: string[];
  setFormResponseOOAComment: (comment: string, valueChecked: boolean) => void;
  sourceIncomeItems: bronzeCategories[];
  isLoadingSourcesIncome: boolean;
  commentProps: string | null;
}) => {
  const { t } = useTranslation(["pass"]);
  const codeOfOriginAsstes = sourceIncomeItems?.find((item) => item.code === 10);
  const [comment, setComment] = useState<string | null>(commentProps);
  const { getLanguage } = usei18n();

  const handleCheckboxChange = (sourceIncome: bronzeCategories, isChecked: boolean) => {
    setFormResponseOOA(sourceIncome, isChecked);
  };
  const handleCommentChange = (value: string) => {
    setComment(value);
    setFormResponseOOAComment(
      value,
      originAssetsProps.includes(codeOfOriginAsstes!.code.toString())
    );
  };
  return (
    <>
      {isLoadingSourcesIncome && (
        <div className="mt-4 mb-4 flex flex-1 items-center justify-center">
          <Loader className="text-gray-500" />
        </div>
      )}
      {!isLoadingSourcesIncome && (
        <div className="flex w-full flex-col" data-cy="origin-assets-categories">
          <div className="my-4 mt-4 grid grid-cols-1 gap-2 md:grid-cols-2">
            {sourceIncomeItems &&
              [...sourceIncomeItems.filter((s) => s.code !== 10), codeOfOriginAsstes].map((c) => (
                <Checkbox
                  key={c?.id}
                  value={
                    originAssetsProps &&
                    originAssetsProps.some((income) => Number(income) === Number(c?.code))
                  }
                  onChange={(value) => handleCheckboxChange(c as bronzeCategories, value)}
                >
                  <Base className="mb-1 cursor-pointer">
                    {getLanguage() === "fr" ? c?.name : c?.english_name}
                  </Base>
                </Checkbox>
              ))}
          </div>

          {originAssetsProps &&
            originAssetsProps.includes(codeOfOriginAsstes?.code.toString() as string) && (
              <div className={"mt-4 mb-4"}>
                <InputLabel
                  onChange={(value: string) => handleCommentChange(value)}
                  value={comment as string}
                  className="mb-1 w-full flex-1 md:mb-0"
                  placeholder={t(
                    "olkypass.mainPage.olkypass.BronzeForms.origins_assets_placeholder"
                  )}
                />
              </div>
            )}
        </div>
      )}
    </>
  );
};
